export function getPrefixCls(cls?: string, customizePrefixCls?: string): string {
  if (customizePrefixCls) {
    return customizePrefixCls;
  }

  return cls ? `gp-${cls}` : "gp";
}
